export default __webpack_public_path__ + "static/media/alternative_metal_band.572f0991.webp";